export default __webpack_public_path__ + "static/media/12.ee3261a9.png";